/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const manualHandlingMskQuestions = [
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheNeck,
        questionText: "Neck",
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheShoulders,
        questionText: "Shoulders",
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheArms,
        questionText: "Arms",
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheWristHandsFingers,
        questionText: "Wrist/Hands/Fingers",
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheUpperSpine,
        questionText: "Upper Spine",
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheLowerSpine,
        questionText: "Lower Spine",
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheLegsHipsKnees,
        questionText: "Legs/Hips/Knees",
    },
    {
        id: questionIds.HaveYouEverSufferedFromAnInjuryOrDisorderOfTheAnklesFeet,
        questionText: "Ankles/Feet",
    },
    {
        id: questionIds.MusculoskeltalInjuryOrDisordersDetails,
        questionText: "If YES, to any of the above, please give specific details:",
    },
    {
        id: questionIds.MusculoskeltalInjuryOrDisordersTreatmentMedicationDetails,
        questionText: "If YES, to any of the above please can you give specific details of any treatment received, including medication, physiotherapy or surgery?",
    },
    {
        id: questionIds.MusculoskeltalInjuryOrDisordersAffectingDailyLivingDetails,
        questionText: "If YES, to any of the above please can you advise if this injury/condition affects functioning in activities of daily living and if so what activities?",
    },
    {
        id: questionIds.WasTheInjuryConditionCausedOrMadeWorseByWork,
        questionText: "Was the injury/condition caused or made worse by work?",
    },
    {
        id: questionIds.DidYouReceiveAnyTreatment,
        questionText: "Did you receive any treatment?",
    },
    {
        id: questionIds.CausedWorseByWorkAndTreatmentDetails,
        questionText: "If YES, to any of the above, please give details:",
    },
    {
        id: questionIds.DoesTheInjuryConditionAffectYourAbilityToWork,
        questionText: "Does the injury/condition affect your ability to work?",
    },
    {
        id: questionIds.DoesTheInjuryConditionAffectYourAbilityToWorkDetails,
        questionText: "If YES, please give details:",
    },
];
